interface PricelistInfo { name: string; tip: string; }

const PRICELIST_MAP: Record<string, PricelistInfo> = {
  'KC-CORE': {
    name: 'King Core',
    tip: [
      'Seattle 98101-98109 98112 98115-98119 98121-22 98125-26 98133-34 98136 98144 98177 98199',
      'Bellevue 98004 98005 98006 98007 98008',
      'Kirkland 98033 98034 98083',
      'Redmond 98052 98053 98073',
      'Mercer Island 98040',
      'Kenmore 98028',
      'Lake Forest Park 98155',
      'Shoreline 98133 98155 98177',
      'Medina 98039 · Clyde Hill 98004 · Hunts Point 98004 · Yarrow Point 98004 · Beaux Arts Village 98004',
      'Woodinville 98072 98077',
    ].join('\n'),
  },
  'KC-SUB': {
    name: 'King Suburbs',
    tip: [
      'Renton 98055 98056 98057 98058 98059',
      'Kent 98030 98031 98032 98042',
      'Auburn 98001 98002 98092',
      'Federal Way 98003 98023 98063',
      'Burien 98146 98148 98166',
      'Tukwila 98168 98178 98188',
      'SeaTac 98148 98158 98188',
      'Des Moines 98198 · Normandy Park 98166 · Pacific 98047 · Algona 98001 · Milton 98354',
      'White Center 98106 98146 · Fairwood 98058 · Boulevard Park 98168',
    ].join('\n'),
  },
  'KC-EAST': {
    name: 'King East',
    tip: [
      'Issaquah 98027 98029 98075',
      'Sammamish 98074 98075',
      'Maple Valley 98038 · Covington 98042',
      'Newcastle 98056 98059 · Black Diamond 98010',
      'Snoqualmie 98065 · North Bend 98045',
      'Duvall 98019 · Carnation 98014 · Enumclaw 98022',
      'Bothell (KC side) 98011 98021',
      'Fall City 98024 · Cottage Lake 98077 · Ravensdale 98051 · Hobart 98025 · Mirrormont 98027',
    ].join('\n'),
  },
  'SN-CORE': {
    name: 'Snohomish Core',
    tip: [
      'Everett 98201 98203 98204 98206 98207 98208 98213',
      'Lynnwood 98036 98037 98046 98087',
      'Edmonds 98020 98026',
      'Mountlake Terrace 98043 · Mukilteo 98275',
      'Brier 98036 · Woodway 98020',
      'Martha Lake 98087 · Alderwood Manor 98036 · Picnic Point 98087',
      'Silver Firs 98208 · Lake Stickney 98204 · Clearview 98290',
    ].join('\n'),
  },
  'SN-EAST': {
    name: 'Snohomish East',
    tip: [
      'Bothell (SN side) 98012 98082',
      'Mill Creek 98012 98082',
      'Snohomish City 98290 98291 98296',
      'Lake Stevens 98258 · Monroe 98272 · Sultan 98294 · Gold Bar 98251',
      'Maltby 98296 · Cathcart 98290 · Echo Lake 98296',
      'Bryant 98258 · Woods Creek 98272 · North Creek 98012',
    ].join('\n'),
  },
  'SN-NRTH': {
    name: 'Snohomish North',
    tip: [
      'Marysville 98270 98271',
      'Arlington 98223 · Stanwood 98292',
      'Granite Falls 98252 · Darrington 98241 · Index 98256',
      'Tulalip 98271 · Warm Beach 98292 · Silvana 98287',
      'Oso 98223 · North Lakewood 98259 · Conway 98238 · Pilchuck 98271',
    ].join('\n'),
  },
};

/** Returns human-readable name + tooltip city/zip list for a Zoho pricelist code. */
export function getPricelistInfo(zohoName: string): PricelistInfo {
  return PRICELIST_MAP[zohoName] ?? { name: zohoName, tip: '' };
}

// ─── Zip → pricelist lookup ────────────────────────────────────────────────────
// Conflicts resolved: KC-SUB wins 98106 (White Center); KC-SUB wins 98042 (Kent/Covington);
// SN-EAST wins 98290 (Snohomish/Cathcart); SN-CORE wins 98204/98208/98087/98036/98020.
const ZIP_PRICELIST: Record<string, string> = {
  // KC-CORE
  '98101':'KC-CORE','98102':'KC-CORE','98103':'KC-CORE','98104':'KC-CORE','98105':'KC-CORE',
  '98107':'KC-CORE','98108':'KC-CORE','98109':'KC-CORE','98112':'KC-CORE',
  '98115':'KC-CORE','98116':'KC-CORE','98117':'KC-CORE','98118':'KC-CORE','98119':'KC-CORE',
  '98121':'KC-CORE','98122':'KC-CORE','98125':'KC-CORE','98126':'KC-CORE',
  '98133':'KC-CORE','98134':'KC-CORE','98136':'KC-CORE','98144':'KC-CORE',
  '98177':'KC-CORE','98199':'KC-CORE',
  '98004':'KC-CORE','98005':'KC-CORE','98006':'KC-CORE','98007':'KC-CORE','98008':'KC-CORE',
  '98033':'KC-CORE','98034':'KC-CORE','98083':'KC-CORE',
  '98052':'KC-CORE','98053':'KC-CORE','98073':'KC-CORE',
  '98040':'KC-CORE','98028':'KC-CORE','98155':'KC-CORE','98039':'KC-CORE',
  '98072':'KC-CORE','98077':'KC-CORE',
  // KC-SUB
  '98055':'KC-SUB','98056':'KC-SUB','98057':'KC-SUB','98058':'KC-SUB','98059':'KC-SUB',
  '98030':'KC-SUB','98031':'KC-SUB','98032':'KC-SUB','98042':'KC-SUB',
  '98001':'KC-SUB','98002':'KC-SUB','98092':'KC-SUB',
  '98003':'KC-SUB','98023':'KC-SUB','98063':'KC-SUB',
  '98146':'KC-SUB','98148':'KC-SUB','98166':'KC-SUB',
  '98168':'KC-SUB','98178':'KC-SUB','98188':'KC-SUB','98158':'KC-SUB',
  '98198':'KC-SUB','98047':'KC-SUB','98354':'KC-SUB','98106':'KC-SUB',
  // KC-EAST
  '98027':'KC-EAST','98029':'KC-EAST','98075':'KC-EAST',
  '98074':'KC-EAST','98038':'KC-EAST',
  '98010':'KC-EAST','98065':'KC-EAST','98045':'KC-EAST',
  '98019':'KC-EAST','98014':'KC-EAST','98022':'KC-EAST',
  '98011':'KC-EAST','98021':'KC-EAST',
  '98024':'KC-EAST','98051':'KC-EAST','98025':'KC-EAST',
  // SN-CORE
  '98201':'SN-CORE','98203':'SN-CORE','98204':'SN-CORE','98206':'SN-CORE',
  '98207':'SN-CORE','98208':'SN-CORE','98213':'SN-CORE',
  '98036':'SN-CORE','98037':'SN-CORE','98046':'SN-CORE','98087':'SN-CORE',
  '98020':'SN-CORE','98026':'SN-CORE','98043':'SN-CORE','98275':'SN-CORE',
  // SN-EAST
  '98012':'SN-EAST','98082':'SN-EAST',
  '98290':'SN-EAST','98291':'SN-EAST','98296':'SN-EAST',
  '98258':'SN-EAST','98272':'SN-EAST','98294':'SN-EAST','98251':'SN-EAST',
  // SN-NRTH
  '98270':'SN-NRTH','98271':'SN-NRTH',
  '98223':'SN-NRTH','98292':'SN-NRTH','98252':'SN-NRTH',
  '98241':'SN-NRTH','98256':'SN-NRTH','98287':'SN-NRTH',
  '98259':'SN-NRTH','98238':'SN-NRTH',
};

/**
 * Given a zip/postal code, returns the matching Zoho pricelist code (e.g. 'KC-CORE'),
 * or null if not in a known service zone.
 */
export function zipToPricelistCode(zip: string): string | null {
  return ZIP_PRICELIST[zip.trim().slice(0, 5)] ?? null;
}
